/**
 * StatisticMenu
 * --
 */
import React from 'react';
import { Descriptions, Table } from 'antd';
import { Content, Title, Row, Col, Statistic, TabMenu } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import * as XLSX from 'xlsx/xlsx.mjs';

/* 

메뉴별 매출 : 사용중인 필드
  menu: 메뉴명
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용금액
*/

/**----------------------------------------
 * [Component] 메뉴별 매출
 * ----------------------------------------
 */
const StatisticMenu = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  dateRange,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];
  const columns = [
    {
      title: '메뉴명',
      dataIndex: 'menu',
      width: '27%',
      fixed: 'left',
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          Total
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (메뉴합산금액) 할인/옵션 포함
          </span>
        </span>
      ),
      dataIndex: 'totalAmount',
      width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    // {
    //   title: (
    //     <span style={{ lineHeight: 0.5 }}>
    //       합계금액
    //       <br />
    //       <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
    //         (결제완료건)
    //       </span>
    //     </span>
    //   ),
    //   dataIndex: 'completedTotalAmount',
    //   width: '14%',
    //   render: (v) => (
    //     <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
    //   ),
    // },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (합계금액 - 환불금액)
          </span>
        </span>
      ),
      dataIndex: 'netSales',
      width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          결제건수
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (결제완료건)
          </span>
        </span>
      ),
      dataIndex: 'paymentsCount',
      width: '9%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    {
      title: '할인금액',
      dataIndex: 'discountAmount',
      width: '9%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    {
      title: '쿠폰적용 주문수',
      dataIndex: 'couponAppliedCount',
      width: '10.5%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    {
      title: '환불금액',
      dataIndex: 'refundAmount',
      width: '9%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
    {
      title: '환불건수',
      dataIndex: 'refundCount',
      width: '9%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
    },
  ];
  /* ===== FUNCTION ===== */
  const handleCalculate = (d, key) => {
    return d.reduce((acc, cur) => acc + Number(cur[key]), 0);
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log('data: ', data);

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12}>
            <Title style={{ marginBottom: 7.5 }}>
              메뉴별 리포트
              {/* {/* {currentShopInfo && `(${currentShopInfo.shop_information_name})`} */}
            </Title>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>
        <div style={{ background: '#fff' }}>
          {data && (
            <Descriptions
              // title="User Info"
              className="boxShadow"
              size="small"
              layout="vertical"
              column={15}
              bordered
              style={{ width: '100%' }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '',
                  contentStyle: { textAlign: 'center' },
                  style: { width: '27%' },
                  children: <p>합계</p>,
                },
                {
                  key: 'totalAmount',
                  label: 'Total',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmount')
                      )}
                    </p>
                  ),
                },
                // {
                //   key: 'completedTotalAmount',
                //   label: '합계금액',
                //   style: { width: '14%' },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(data, 'completedTotalAmount')
                //       )}
                //     </p>
                //   ),
                // },
                {
                  key: 'netSales',
                  label: '순매출',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(handleCalculate(data, 'netSales'))}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCount',
                  label: '결제건수',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'discountAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'couponAppliedCount',
                  label: '쿠폰적용 주문수',
                  style: { width: '10.5%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'couponAppliedCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundAmount',
                  label: '환불금액',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundCount',
                  label: '환불건수',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundCount')
                      )}
                    </p>
                  ),
                },
              ]}
            />
          )}
        </div>
        <br />

        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            columns={columns}
            scroll={{
              x: 'max-content',
            }}
            style={{ minHeight: 580 }}
          />
        </div>
      </Content>
    </>
  );
};

export default StatisticMenu;
